import { createContext, useContext } from 'react'

interface ISignUpClinicContextType {
  goNextStep: () => void
  goBackStep: () => void
}

export const SignUpClinicContext = createContext<ISignUpClinicContextType>({
  goNextStep: () => {},
  goBackStep: () => {},
})

export const useSignUpClinicContext = () => {
  const context = useContext(SignUpClinicContext)
  return context
}
